import { render, staticRenderFns } from "./CalendarioMidiaSociais.vue?vue&type=template&id=eb33c0d8"
import script from "./CalendarioMidiaSociais.vue?vue&type=script&lang=js"
export * from "./CalendarioMidiaSociais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports